export type PostCalculatedItemPriceForSubcontractApiResponse =
  | /** status 200 Standard response */ ({
      purchaseTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      sellingTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostCalculatedItemPriceForSubcontractApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    sellingPricePerUnit: {
      amount: number;
      currency: string;
    } | null;
    purchasePricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vatType: string;
    discountRate?: number | null;
  } | null;
};
export type GetCalculatedItemPriceForCalculationPriceApiResponse =
  | /** status 200 Standard response */ ({
      sellingTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      purchaseTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCalculatedItemPriceForCalculationPriceApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    quantity: number | null;
    sellingPricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    purchasePricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vatType: string | null;
    discountRate?: number | null;
  } | null;
};
export type GetCalculatedItemPriceForCooperationApiResponse =
  | /** status 200 Standard response */ ({
      sellingTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      purchaseTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCalculatedItemPriceForCooperationApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    sellingPricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    purchasePricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vatType: string | null;
    discountRate?: number | null;
  } | null;
};
export type GetCalculatedItemPriceForDirectPriceApiResponse =
  | /** status 200 Standard response */ ({
      sellingTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      purchaseTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCalculatedItemPriceForDirectPriceApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    sellingPricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    purchasePricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vatType: string | null;
    discountRate?: number | null;
  } | null;
};
export type GetCalculatedItemPriceForTimeNormApiResponse =
  | /** status 200 Standard response */ ({
      sellingPricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      sellingTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      purchaseTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCalculatedItemPriceForTimeNormApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    quantity: number | null;
    workType: string | null;
    sellingPricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vatType: string | null;
    discountRate?: number | null;
    assignMechanics?: ({
      id?: string;
      isDefault?: boolean;
      costCenterId?: string | null;
      amount?: number;
      ratio?: number | null;
    } | null)[];
  } | null;
};
export type GetServiceOrderJobItemWorkApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      labourCatalogId?: string | null;
      labourRateId?: string | null;
      priceType?:
        | (
            | 'SVCPRICETYPE_TIME_NORM'
            | 'SVCPRICETYPE_CALCULATION_PRICE'
            | 'SVCPRICETYPE_DIRECT_PRICE'
            | 'SVCPRICETYPE_COOPERATION'
            | 'SVCPRICETYPE_SUBCONTRACT'
          )
        | null;
      workType?: string | null;
      workItemGroupId?: string | null;
      timeOutputPerUnit?: number | null;
      name?: string | null;
      number?: string | null;
      quantity?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      isUnitPriceWithVat?: boolean | null;
      basePurchasePricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      baseSellingPricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      baseSellingPriceVat?: {
        type?: string | null;
      } | null;
      isCustomPrice?: boolean | null;
      isCustomPriceEditingAllowed?: boolean | null;
      purchasePricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
        isEditingAllowed?: boolean | null;
      } | null;
      sellingPricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
        isEditingAllowed?: boolean | null;
      } | null;
      sellingPriceVat?: {
        type?: string | null;
        freeCode?: string | null;
        isEditingAllowed?: boolean | null;
      } | null;
      assignMechanics?: ({
        id?: string | null;
        name?: string | null;
        isDefault?: boolean | null;
        costCenterId?: string | null;
        amount?: number | null;
      } | null)[];
      isEditingAllowed?: boolean | null;
      isQuantityEditingAllowed?: boolean | null;
      isDiscount?: boolean | null;
      isDoNotApplyDiscount?: boolean | null;
      isDoNotApplyDiscountEditable?: boolean | null;
      muloConversion?: {
        conversionRatio?: number | null;
        quantity?: number | null;
        mulo?: string | null;
      } | null;
      discount?: {
        isDoNotApplyDiscount: boolean;
        isEditingAllowed: boolean;
        availableDiscounts?: ({
          isSelected: boolean;
          sourceType: 'customer-contract' | 'custom-discounts' | 'manual-discount';
          source?: string | null;
          rate?: number | null;
          isEditingAllowed: boolean;
        } | null)[];
      } | null;
      goodwill?: {
        goodwillRatio?: number | null;
        isGoodwillChangeAllowed?: boolean | null;
        goodwillOrders?: ({
          serviceOrderId?: string | null;
          serviceOrderVariantId?: string | null;
          serviceOrderNo?: string | null;
          serviceJobName?: string | null;
          isServiceOrderParent?: boolean | null;
          goodwillRatio?: number | null;
        } | null)[];
      } | null;
      purchasePriceTotal?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      sellingPriceTotal?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      discountTotal?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ void;
export type GetServiceOrderJobItemWorkApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
};
export type PatchOrderItemForWorkApiResponse =
  | /** status 200 Standard response */ ({
      workBasketItem?: {
        id?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchOrderItemForWorkApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    priceType:
      | (
          | 'SVCPRICETYPE_TIME_NORM'
          | 'SVCPRICETYPE_CALCULATION_PRICE'
          | 'SVCPRICETYPE_DIRECT_PRICE'
          | 'SVCPRICETYPE_COOPERATION'
          | 'SVCPRICETYPE_SUBCONTRACT'
        )
      | null;
    name: string;
    number?: string | null;
    workType: string;
    labourRateId: string;
    assignMechanics?: ({
      id: string;
      isDefault: boolean;
      costCenterId?: string | null;
      amount: number;
    } | null)[];
    quantity: number;
    isUnitPriceWithVat: boolean;
    purchasePricePerUnit?: number | null;
    sellingPricePerUnit: number;
    sellingPriceVat?: {
      type?: string | null;
      freeCode?: string | null;
    } | null;
    isCustomPrice: boolean;
    isDiscount: boolean;
    isDoNotApplyDiscount: boolean;
    workItemGroupId?: string | null;
    timeOutputPerUnit?: number | null;
    discount?: {
      sourceType: string;
      source?: string | null;
      rate: number;
    } | null;
  } | null;
};
export type PutServiceOrderItemsToOtherOrderJobApiResponse = unknown;
export type PutServiceOrderItemsToOtherOrderJobApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    serviceMoveToOrderId: string;
    serviceMoveToJobId: string;
    items: ({
      serviceJobId: string;
      serviceItemId: string;
    } | null)[];
  } | null;
};
export type GetOrderItemForMaterialApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      warehouse?: {
        warehouseId?: string | null;
        manufacturerId?: string;
        warehouseArticleId?: string | null;
        storageLocation?: string | null;
        warehouseAction?: string | null;
        dispensingUnit?: number | null;
        neededAt?: string | null;
      } | null;
      name?: string | null;
      number?: string | null;
      quantity?: {
        amount?: number | null;
        unit?: string | null;
      } | null;
      isUnitPriceWithVat?: boolean | null;
      isCustomPriceEditingAllowed?: boolean | null;
      purchasePricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
        isEditingAllowed?: boolean | null;
      } | null;
      sellingPricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
        isEditingAllowed?: boolean | null;
      } | null;
      sellingPriceVat?: {
        type?: string | null;
        freeCode?: string | null;
        isEditingAllowed?: boolean | null;
      } | null;
      assignMechanic?: string | null;
      isCustomPrice?: boolean | null;
      baseSellingPricePerUnit?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      baseSellingPriceVat?: {
        type?: string | null;
      } | null;
      isEditingAllowed?: boolean | null;
      isQuantityEditingAllowed?: boolean | null;
      isDiscount?: boolean | null;
      isDoNotApplyDiscount?: boolean | null;
      isDoNotApplyDiscountEditable?: boolean | null;
      defaultSupplierDiscountGroupId?: string | null;
      defaultSupplierId?: string | null;
      workItemGroupId?: string | null;
      discount?: {
        isDoNotApplyDiscount: boolean;
        isEditingAllowed: boolean;
        availableDiscounts?: ({
          isSelected: boolean;
          sourceType: 'customer-contract' | 'custom-discounts' | 'manual-discount';
          source?: string | null;
          rate?: number | null;
          isEditingAllowed: boolean;
        } | null)[];
      } | null;
      goodwill?: {
        goodwillRatio?: number | null;
        isGoodwillChangeAllowed?: boolean | null;
        goodwillOrders?: ({
          serviceOrderId?: string | null;
          serviceOrderVariantId?: string | null;
          serviceOrderNo?: string | null;
          serviceJobName?: string | null;
          isServiceOrderParent?: boolean | null;
          goodwillRatio?: number | null;
        } | null)[];
      } | null;
      purchasePriceTotal?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      sellingPriceTotal?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      articleSalePrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      articlePriceIndicator?: 'EQUAL' | 'HIGHER' | 'LOWER' | 'NO_PRICE' | null;
      discountTotal?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetOrderItemForMaterialApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
};
export type PatchOrderItemForMaterialApiResponse = /** status 204 Standard response */ undefined;
export type PatchOrderItemForMaterialApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    quantity: number;
    isUnitPriceWithVat: boolean;
    sellingPricePerUnit: number;
    sellingPriceVat?: {
      type?: string | null;
      freeCode?: string | null;
    } | null;
    mechanic: string | null;
    isCustomPrice: boolean;
    isDiscount: boolean;
    isDoNotApplyDiscount: boolean;
    discount?: {
      sourceType: string;
      source?: string | null;
      rate: number;
    } | null;
    originEntityHeaderType?: string;
    originEntityHeaderId?: string;
    workItemGroupId?: string | null;
  } | null;
};
export type PostOrderItemCalculatePriceApiResponse =
  | /** status 200 Standard response */ ({
      sellingTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      purchaseTotalPrice?: {
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      marginTotal?: {
        marginPercentage?: number | null;
        isMarginUnderMinimum?: boolean | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      articleSalePrice?: {
        marginPercentage?: number | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      articlePriceIndicator?: 'EQUAL' | 'HIGHER' | 'LOWER' | 'NO_PRICE' | null;
      discount?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostOrderItemCalculatePriceApiArg = {
  /** UUID */
  serviceCaseId: string | null;
  /** UUID */
  serviceOrderId: string | null;
  /** UUID */
  serviceJobId: string | null;
  /** UUID */
  serviceItemId: string | null;
  body: {
    quantity: number;
    sellingPricePerUnit: {
      amount: number;
      currency: string;
    } | null;
    purchasePricePerUnit?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vatType: string;
    discountRate?: number | null;
    getCurrentPrice?: boolean | null;
  } | null;
};
export type GetOneTimeSaleForMaterialItemApiResponse = {
  isOneTimeSale: boolean;
  isEditingAllowed: boolean;
};
export type GetOneTimeSaleForMaterialItemApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
};
export type PutOneTimeSaleForMaterialItemApiResponse = null;
export type PutOneTimeSaleForMaterialItemApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    isOneTimeSale: boolean;
  } | null;
};
export type PostServiceOrderItemReplaceWithAlternativeApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceOrderItemReplaceWithAlternativeApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  /** UUID */
  serviceJobId: string;
  /** UUID */
  serviceItemId: string;
  body: {
    /** UUID */
    warehouseArticleId: string;
  } | null;
};
